import { render, staticRenderFns } from "./ListTruncatedCell.vue?vue&type=template&id=453d0518&"
import script from "./ListTruncatedCell.vue?vue&type=script&lang=ts&"
export * from "./ListTruncatedCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports